var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-basic"},[_c('BtnGoTop'),_c('div',[_c('NavBar')],1),_c('div',{staticClass:"layout-basic-content"},[_vm._t("default")],2),_c('div',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }